'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = quickOrder;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function quickOrder() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'GET_FILTERED_PRODUCTS':
      return state;
    case 'GET_FILTERED_PRODUCTS_SUCCESS':
      return action.result;
    case 'GET_FILTERED_PRODUCTS_FAILURE':
      return (0, _extends3.default)({}, state, { error: action.error });
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/quickOrder.js
// module id = 2357
// module chunks = 0